import { type CountryCode, ProjectCode } from '@constants'
import { colorTheme as aquaColorTheme } from '@pets-ui/themes/aqua'
import { colorTheme as dcsColorTheme } from '@pets-ui/themes/dcs'
import { colorTheme as fastpassColorTheme } from '@pets-ui/themes/fastpass'
import { colorTheme as hmColorTheme } from '@pets-ui/themes/hm'
import { colorTheme as lmColorTheme } from '@pets-ui/themes/lm'
import { colorTheme as mnpColorTheme } from '@pets-ui/themes/mnp'
import { colorTheme as pmColorTheme } from '@pets-ui/themes/pm'
import { colorTheme as ppColorTheme } from '@pets-ui/themes/pp'
import { colorTheme as ytColorTheme } from '@pets-ui/themes/yt'
import { type Colors } from '@pets-ui/tokens/colors.stylex'
import { type Theme } from '@stylexjs/stylex'

export const BrandCategory = {
  PET: 'pet',
  HUMAN: 'human',
} as const

export type BrandCategory = typeof BrandCategory[keyof typeof BrandCategory]

export interface BrandInfo {
  campaignCode: string
  campaignId: number
  projectCode: ProjectCode
  countryCode: CountryCode
  category: BrandCategory
}

export const colorThemeMap: Partial<Record<ProjectCode, Theme<Colors>>> = {
  [ProjectCode.DCS]: dcsColorTheme,
  [ProjectCode.HM]: hmColorTheme,
  [ProjectCode.LM]: lmColorTheme,
  [ProjectCode.MNP]: mnpColorTheme,
  [ProjectCode.AQUA]: aquaColorTheme,
  [ProjectCode.PP]: ppColorTheme,
  [ProjectCode.PM]: pmColorTheme,
  [ProjectCode.YT]: ytColorTheme,
}

export { fastpassColorTheme }
